import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from './store/actions';
import { Button, Tab, Tabs, Grid, Divider, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import * as validatorActions from '../../components/validator/store/actions';
import QualificationForm from './QualificationForm';
import * as companyActions from '../company/store/actions';
import TabPanelButtons from '../../components/TabPanelButtons';
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64,
        flex: 1
    },
    tabRoot: {
        height: 64,
        [theme.breakpoints.up('md')]: {
            minWidth: '144px'
        }
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%'
    },
});

class Qualification extends Component {
    state = {
        current_tab: 0,
        qualification_id: 0,
        view_type: '',
        tabValue: 0,
        deleteDialogActive: false
    }

    constructor(props) {
        super(props);

        const qualification_id = this.props.match.params.qualification_id;
        const view_type = this.props.match.params.view_type;

        this.state = {
            ...this.state,
            qualification_id: qualification_id,
            view_type: view_type,
        }

        this.props.updateQualificationLoaded(false);
        this.props.getQualificationData(qualification_id);
        this.props.get
        this.props.getAllCompanies();

        const validationList = [
            {
                field_name: 'QualificationName', functionName: ['checkRequiredFilled']
            }
        ]

        this.props.startValidator(validationList)
    }

    handleSubmit = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        switch (this.state.view_type) {
            case ("create"):
                {
                    this.props.saveQualification(this.props.currentQualification, auth_id);

                    this.props.history.push('/qualification/list');
                    break;
                }

            case ("edit"):
                {
                    this.props.saveQualification(this.props.currentQualification, auth_id);

                    this.props.history.push('/qualification/list');
                    break;
                }

            default:
                {

                }
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ deleteDialogActive: true })
    }

    handleDelete = () => {
        switch (this.state.view_type) {
            case ("edit"):
                {
                    this.props.deleteQualification(this.props.currentQualification.qualification_id);
                    this.props.history.push('/qualification/list');
                    break;
                }

            default:
                {

                }

        }
    }

    getPageContent = (view_type) => {
        const { classes, currentQualification, theme } = this.props;

        return (
            <QualificationForm
                view_type={view_type}
                allCompanies={this.props.allCompanies}
            />
        )



    }

    getDeleteDialog = (active, qualification) => {
        return (
            <Dialog
                open={active}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onBackdropClick={() => this.setState({ deleteDialogActive: false })}
            >
                <DialogTitle>Confirm Delete {qualification.QualificationName}?</DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleDelete()} color="primary">
                        Delete
                        </Button>
                    <Button onClick={() => this.setState({ deleteDialogActive: false })} color="primary" autoFocus>
                        Go Back
                        </Button>
                </DialogActions>
            </Dialog>

        )
    }

    disableSave = () => {
        const { validator } = this.props;
        const { view_type } = this.state

        switch (view_type) {
            case ("edit"): {
                return (
                    validator.map(v => v.error)
                        .includes(true)
                )
            }
            case ('create'): {
                return !(
                    validator.every(v => v.error === false)
                )
            }
        }
    };

    render() {
        const { classes, currentQualification, isQualificationLoaded } = this.props;
        const { view_type } = this.state;
        const delete_dialog = this.getDeleteDialog(this.state.deleteDialogActive, this.props.currentQualification)

        if (!isQualificationLoaded) {
            return <div>loading</div>
        }

        let page_content = <React.Fragment>Loading...</React.Fragment>;
        if (isQualificationLoaded) {
            page_content = this.getPageContent(view_type);
        }

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <PageHeader
                        component_name = {currentQualification.QualificationName}
                        component_type = {"qualification"}
                        view_type      = {view_type}
                    />
                }
                contentToolbar={
                    <div style={{ width: '100%', height: '100%', }}>
                        {/* The div below is only for properly pushing the buttons to the right in lieu of tabs. If tabs get added, delete this div. */}
                        <div className="flex items-center justify-end" style={{ height: '64px' }}>
                            <TabPanelButtons
                                component_name = {"qualification"}
                                view_type      = {view_type}
                                button_list    = {[
                                    {
                                        display:  "Save",
                                        type:     "update",
                                        onClick:  this.handleSubmit,
                                        disabled: this.disableSave(),
                                    },
                                    {
                                        type:    "delete",
                                        onClick: this.handleDeleteDialogOpen,
                                    },
                                    {
                                        type:    "back",
                                        onClick: this.props.history.goBack,
                                    }
                                ]}
                            />
                        </div>
                    </div>

                }
                content={
                    <React.Fragment>
                        <div className="p-24">
                            {delete_dialog}
                            {page_content}
                        </div>
                        {/* <div className="p-24">
                            {button_content}
                        </div> */}
                    </React.Fragment>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQualification: Actions.getQualification,
        getQualificationData: Actions.getQualificationData,
        saveQualification: Actions.saveQualification,
        deleteQualification: Actions.deleteQualification,
        updateQualificationLoaded: Actions.updateQualificationLoaded,
        startValidator: validatorActions.startValidator,
        getAllCompanies: companyActions.getCompanyList,
    }, dispatch);
}

function mapStateToProps({ qualificationApp, validator, companyApp, auth }) {
    return {
        currentQualification: qualificationApp.qualifications.currentQualification,
        isQualificationLoaded: qualificationApp.qualifications.isQualificationLoaded,
        validator: validator.list,
        allCompanies: companyApp.companies.companyList,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Qualification)));



// WEBPACK FOOTER //
// src/main/content/qualification/Qualification.js